import React from "react";
import Footer from "./Footer";
import NavBar from "./NavBar";
import { useMediaQuery, useTheme } from "@mui/material";

const GSTAnnualReturn = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // Mobile breakpoint at 900px

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f5f5f5",
        margin: 0,
        padding: 0,
      }}
    >
      <NavBar />

      {/* Header */}
      <div
        style={{
          backgroundColor: "#00b050",
          color: "white",
          padding: isMobile ? "15px" : "30px",
          fontSize: isMobile ? "20px" : "28px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "65px",
        }}
      >
        GST Annual Return
      </div>

      {/* Intro Paragraph */}
      <p
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "20px auto",
          padding: isMobile ? "10px" : "20px",
          fontSize: isMobile ? "14px" : "16px",
        }}
      >
        Since its introduction on July 1, 2017, GST in India has registered over
        1.3 crore businesses, mandating all GST-registered entities to file
        annual returns, regardless of activity, sales, or profitability, as per
        the designated schedule.
      </p>

      {/* Content */}
      <div
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "15px auto",
          padding: isMobile ? "10px" : "20px",
        }}
      >
        <div
          style={{
            background: "white",
            padding: isMobile ? "15px" : "25px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            lineHeight: "1.6",
            color: "#333",
          }}
        >
          {/* Filing Requirements */}
          <div>
            <h2
              style={{
                color: "#001F3F",
                fontWeight: 600,
                marginBottom: isMobile ? "4px" : "6px",
                fontFamily: "Times New Roman, Georgia, serif",
                fontSize: isMobile ? "18px" : "24px",
              }}
            >
              Filing Requirements
            </h2>
            <div
              style={{
                width: "80px",
                height: "3px",
                background: "#22c55e",
                borderRadius: "2px",
              }}
            ></div>
          </div>

          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            All GST-registered entities, including dormant businesses, must file
            annual returns. For the financial year 2017-18, those registered
            before April 1, 2018, were required to submit by June 30, 2019,
            provided all prior GSTR-1, GSTR-3B, or GSTR-4 returns from July to
            March 2018 were filed. Overdue returns block annual return
            submission.
          </p>

          {/* Return Categories */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Return Categories
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <ul
            style={{
              paddingLeft: isMobile ? "15px" : "20px",
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            <li>
              <strong>GSTR-9:</strong> Mandatory for all GST-registered entities
              to file their annual return.
            </li>
            <li>
              <strong>GSTR-9A:</strong> Required for taxpayers under the GST
              Composition Scheme.
            </li>
            <li>
              <strong>GSTR-9C:</strong> A reconciliation statement for taxpayers
              with an annual turnover above Rs. 2 crores, certified by a
              Chartered Accountant or Cost Accountant.
            </li>
          </ul>

          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            GSTR-9C applies to entities needing a GST audit, reconciling GSTR-9
            data with audited financial statements. The government has simplified
            these forms, making certain fields optional for ease of filing.
          </p>

          {/* Submission Deadlines */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Submission Deadlines
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            For 2017-18, GSTR-9 and GSTR-9C were due by December 31, 2019, while
            for 2018-19, the deadline was March 31, 2020. These dates reflect the
            government’s efforts to streamline compliance.
          </p>

          {/* Supporting Documentation */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Supporting Documentation
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Taxpayers must submit prior monthly returns (GSTR-1, GSTR-3B, or
            GSTR-4), financial statements (for GSTR-9C), and GST registration
            details to complete the annual return process.
          </p>

          {/* Closing Reflections */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Closing Reflections
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            GST annual return filing is a critical compliance obligation for all
            registered entities in India, ensuring transparency and adherence to
            tax laws. Timely submission with complete documentation is essential
            to avoid disruptions.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default GSTAnnualReturn;